module.exports = __webpack_public_path__ + "img/gotoTop@3x.a1235216.png";